var DevOps = "DevOps";
var Gaming = "Videojuegos";
var Migration = "Migración";
var Other = "Otro";
var useCase = {
	"Use case": "Caso de uso",
	"AI & machine learning": "IA y machine learning",
	"Batch processing": "Procesamiento en lotes",
	"Big data, analytics, & business intelligence": "Big data, análisis e inteligencia empresarial",
	"Business applications - Microsoft": "Aplicaciones empresariales - Microsoft",
	"Business applications - Oracle": "Aplicaciones empresariales - Oracle",
	"Business applications - Other": "Aplicaciones empresariales - Otro",
	"Business applications - SAP": "Aplicaciones empresariales - SAP",
	"Content delivery": "Entrega de contenido",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "Internet de las cosas",
	"Learning & certification": "Capacitación y certificación",
	"Media services": "Servicios multimedia",
	Migration: Migration,
	"Mobile applications": "Aplicaciones móviles",
	Other: Other,
	"Storage & backup": "Almacenamiento y copias de seguridad",
	"Websites & web apps": "Sitios web y aplicaciones web"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
